module.exports = __webpack_public_path__ + "img/sort_down.08044633.svg";